import {instanceAxios} from "@/axios/axios";
import cookie from "js-cookie";

export default function postModalNewAddress(data) {
    return new Promise((resolve, reject) => {
        instanceAxios.post('addAddresses', data,{params: {userToken: cookie.get('token')}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}